import {ResearchLitElement, html, css} from '@core/research-lit-element';
import '@bog-design-system/bd-font';

import '../../../common/layout/research-section';
import '../../../common/research-product-promo-card';

class researchCatalogMethodsSection extends ResearchLitElement {
    static get is() {
        return 'research-catalog-methods-section';
    }

    static get styles() {
        return css`
            .methods-title,
            .method-card-title {
                color: var(--color-invert-component-tr-20);
            }

            .methods-description {
                color: var(--color-invert-component-tr-30);
                max-width: 837px;
            }

            .header-block {
                display: flex;
                flex-direction: column;
                gap: var(--space-12);
            }

            .methods-list {
                margin-top: var(--space-32);
                display: grid;
                grid-template-columns: repeat(3, 1fr);
                gap: var(--space-32) var(--space-24);
            }

            .method-card {
                --card-width: 100%;
                --card-padding: var(--space-32);
                --card-border-radius: var(--border-radius-38);
                --card-bg-color: var(--color-pfm-other-expenses-background);
                --card-border: solid 1px var(--color-pfm-other-expenses-background);
            }

            .method-card:nth-child(3n) {
                --card-bg-color: var(--color-pfm-shopping-background);
                --card-border: solid 1px var(--color-pfm-shopping-other);
            }

            .method-card-description {
                color: var(--color-invert-component-tr-40);
                margin-bottom: 0;
            }

            @media (max-width: 1024px) {
                .methods-section {
                    padding-top: var(--space-48);
                    padding-bottom: var(--space-48);
                }
            }

            @media (max-width: 768px) {
                .methods-list {
                    grid-template-columns: 1fr;
                    gap: var(--space-24);
                }

                .method-card:nth-child(3n) {
                  --card-bg-color: var(--color-pfm-other-expenses-background);
                  --card-border: solid 1px var(--color-pfm-other-expenses-background);
                }

                .method-card:last-child,
                .method-card:nth-last-child(2) {
                    --card-bg-color: var(--color-pfm-shopping-background);
                    --card-border: solid 1px var(--color-pfm-shopping-other);
                }
                
                .method-card-title h4 {
                  font-size: calc(var(--space-16) + var(--space-2));
                }
            }

            @media (max-width: 600px) {
                .methods-section {
                    padding-top: var(--space-32);
                    padding-bottom: var(--space-32);
                    --border-space: var(--space-16);
                }

                .header-block {
                    padding: 0 var(--space-8);
                }

                .methods-list {
                    margin-top: var(--space-24);
                }

                .method-card {
                    --card-padding: var(--space-24);
                }
            }
        `;
    }

    render() {
        return html`
          <research-section class="methods-section">
              <div class="header-block">
                  <bd-font type="${this._isTablet ? 'h2' : 'overline-large'}">
                      <h2 class="methods-title">${this.data.title}</h2>
                  </bd-font>
                  ${this.data?.description ?
                    html`
                        <bd-font type="body1" class="methods-description">
                            <span>${this.data.description}</span>
                        </bd-font>
                    ` :
                    ''}
              </div>

              <div class="methods-list">
                  ${this.data.list.map(
                      (item) => html`
                          <research-product-promo-card hide-img static class="method-card">
                              <bd-font type="title" slot="title" class="method-card-title"
                                  ><h4>${item.title}</h4>
                              </bd-font
                              >
                              <bd-font type="body2" slot="description" class="method-card-description"
                                  ><span>${item.description}</span></bd-font
                              >
                          </research-product-promo-card>
                      `
                  )}
              </div>
          </research-section>
        `;
    }

    static get properties() {
        return {
            data: {
                type: Object,
            },
        };
    }

    constructor() {
        super();
        this.data = {};
        this._isTablet = window.matchMedia(`(max-width: 768px)`).matches;
    }
}

window.customElements.define(researchCatalogMethodsSection.is, researchCatalogMethodsSection);
